import React from 'react';

function ProductFormat(props) {
    return (
        <div>
            <h1>Product Format</h1>
        </div>
    );
}

export default ProductFormat;